import { useState } from "react";
import { useAvtovazRequisites } from "~/entity/AvtovazRequisites";

export const useDeactivateRequisite = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const { deactivateAvtovazRequisite } = useAvtovazRequisites();

  const mutate = async (id: number) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);
    try {
      await deactivateAvtovazRequisite(id);
      setIsSuccess(true);
    } catch (error) {
      setError("Ошибка деактивации");
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, mutate, isSuccess };
};
